export default {"src":"/_next/static/media/home_form_decoration.90ff2de9.svg","height":589,"width":1365,"blurWidth":0,"blurHeight":0};